import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import { useTheme } from "../../context/ThemeContext";

function NtCallingRatesStatItem({
  title,
  value,
  containerStyle,
  showSlashMin = true,
  icon,
  tone = "brand",
}) {
  const { theme } = useTheme();
  const accent = theme[tone] || theme.brand;
  const styles = useMemo(() => makeStyles(theme, accent), [theme, accent]);

  return (
    <View style={[styles.container, containerStyle]}>
      {icon ? (
        <View style={styles.iconWrap}>
          <NtMaterialIcon name={icon} size={18} color={accent} />
        </View>
      ) : null}
      <View style={{ flex: 1 }}>
        <NtText style={styles.title}>{title}</NtText>
        <NtText style={styles.value}>
          {value}
          {showSlashMin ? <NtText style={styles.unit}>/min</NtText> : ""}
        </NtText>
      </View>
    </View>
  );
}

const makeStyles = (t, accent) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      gap: 12,
      minWidth: 170,
      paddingHorizontal: 14,
      paddingVertical: 12,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
    },
    iconWrap: {
      width: 36,
      height: 36,
      borderRadius: 8,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: accent + "20",
    },
    title: { fontSize: 11, fontWeight: "500", color: t.textDim },
    value: {
      fontSize: 20,
      fontWeight: "700",
      color: t.text,
      marginTop: 2,
      letterSpacing: -0.3,
    },
    unit: { fontSize: 11, fontWeight: "500", color: t.textDim },
  });

export default NtCallingRatesStatItem;
